var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11510_19939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.165 9.99996C19.165 15.0617 15.0617 19.165 9.99996 19.165C4.93827 19.165 0.834961 15.0617 0.834961 9.99996C0.834961 4.93827 4.93827 0.834961 9.99996 0.834961C15.0617 0.834961 19.165 4.93827 19.165 9.99996ZM10.5107 3.10385C10.1942 2.92111 9.80423 2.92111 9.48772 3.10385L4.11035 6.20847C3.91698 6.32012 3.79785 6.52645 3.79785 6.74974V12.959C3.79785 13.3245 3.99283 13.6622 4.30934 13.8449L9.6867 16.9495C9.88008 17.0612 10.1183 17.0612 10.3117 16.9495L15.6891 13.8449C16.0056 13.6622 16.2006 13.3245 16.2006 12.959V6.74974C16.2006 6.52645 16.0814 6.32012 15.8881 6.20847L10.5107 3.10385ZM5.67285 6.74974L9.9992 4.25192L14.3256 6.74974L12.2392 7.95431C11.6882 7.34226 10.889 6.95635 9.99928 6.95635C9.10948 6.95635 8.3103 7.34228 7.75932 7.95436L5.67285 6.74974ZM12.8648 9.03649L14.9506 7.83227V12.8279L10.6242 15.3257L10.6243 12.9171C11.9883 12.6294 13.0121 11.4188 13.0121 9.96918C13.0121 9.64416 12.9604 9.33053 12.8648 9.03649ZM9.37427 12.9171L9.37422 15.3257L5.04785 12.8279V7.83227L7.13375 9.03656C7.0381 9.33058 6.98644 9.64418 6.98644 9.96918C6.98644 11.4188 8.01026 12.6293 9.37427 12.9171ZM8.47195 9.08813C8.7777 8.55964 9.3476 8.20635 9.99928 8.20635C10.6509 8.20635 11.2208 8.55962 11.5266 9.08809C11.6763 9.34677 11.7621 9.647 11.7621 9.96918C11.7621 10.9428 10.9729 11.732 9.99928 11.732C9.02569 11.732 8.23644 10.9428 8.23644 9.96918C8.23644 9.64702 8.32229 9.3468 8.47195 9.08813Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11510_19939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultInverse);
export default __webpack_public_path__ + "static/media/default-inverse.8d1f0a1923abb6c2ba4f5e75143a0c1a.svg";
export { ForwardRef as ReactComponent };